<template>
    <div v-show="isActive" class="pp-tab-panel">
        <slot></slot>
    </div>
</template>

<script>
/**
 * 标签面板
 * @param {String} name 标识（unique，同级同名不会插入父级tab）
 * @param {String} label 展示名称
 * @param {String} icon 前缀图标
 */
export default {
    name: 'pp-tab-panel',
    props: {
        name: String,
        label: String,
        icon: String,
    },
    computed: {
        parent: function() {
            return this.$parent.$options.name === 'pp-tab'
                ? this.$parent
                : null;
        },
        isActive: function() {
            return this.parent 
                ? this.parent.value === this.name 
                : false;
        },
    },
    created: function() {
        this.insert()
    },
    methods: {
        insert: function() {
            let result = this.parent.tabs.find(v=> v.name === this.name);
            if(!result || !tabs.length) {
                this.parent.tabs.push(this.$options.propsData)
            }
        },
    },
}
</script>

<style>

</style>
